import React from 'react';
import { find, get, isEmpty, map } from 'lodash';

import { ATLAS_ELEMENTS, ATLAS_PROP_TYPES } from '../ui/atoms/AtlasAtoms/atlas-elements';

/**
 * Gets the props object of the Atlas element from the form.
 *
 * @param {object} arg - The object argument.
 * @param {string} arg.name - The name of the atlas prop.
 * @param {string} arg.value - The name of the atlas element.
 * @param {string} arg.type - The type of the atlas prop.
 * @param {object} arg.index - The index of the prop on the array.
 * @param {object} arg.form - The form.
 * @param {object} [arg.getComponent] - Flag to add the components to the final object.
 * @returns {object} - The props object.
 */
const getAtlasPropFromForm = ({ name, value, type, form, index, getComponent = true }) => {
  let selectedNode;
  let nodeProperties;
  let nodeProps;
  let nodeValue;
  let propsObject;
  let formObject;
  let childNodeValue;
  let nodeComponent;
  let elementProps;
  let propValue;
  const formName = `${value}-${index}-prop-${name}`;
  switch (type) {
    case ATLAS_PROP_TYPES.STRING:
    case ATLAS_PROP_TYPES.SELECT:
    case ATLAS_PROP_TYPES.TEXTAREA:
    case ATLAS_PROP_TYPES.COLOR:
      propValue = get(form, [formName, 'value'], '');
      // As propValue can be an empty string (e.g. when the field is not filled), this is to ensure
      // that value is not saved in Mongo and later used as a prop for the atlas, using instead the
      // default one defined in the corresponding atlas element.
      return {
        propName: name,
        propValue: isEmpty(propValue) ? undefined : propValue
      };
    case ATLAS_PROP_TYPES.NODE:
      selectedNode = get(form, [formName, 'value'], '');
      if (isEmpty(selectedNode)) return { propName: name };
      nodeProperties = find(ATLAS_ELEMENTS.properties, ['value', selectedNode]) || '';
      ({ props: nodeProps, value: nodeValue } = nodeProperties);
      childNodeValue = `${formName}-${nodeValue}`;
      propsObject = {};
      elementProps = map(nodeProps, ({ name: nodeName, type: nodeType }, nodeIndex) => {
        formObject = getAtlasPropFromForm({
          name: nodeName,
          value: childNodeValue,
          type: nodeType,
          index: nodeIndex,
          form
        });
        propsObject[formObject.propName] = formObject.propValue;
        return formObject;
      });
      if (getComponent) {
        ({ component: nodeComponent } = find(ATLAS_ELEMENTS.properties, ['value', selectedNode]));
        nodeComponent = React.cloneElement(nodeComponent, propsObject);
        return {
          propName: name,
          propValue: { elementName: selectedNode, elementProps, component: nodeComponent }
        };
      }
      return {
        propName: name,
        propValue: { elementName: selectedNode, elementProps }
      };
    default:
      return {};
  }
};

export default getAtlasPropFromForm;
